// extracted by mini-css-extract-plugin
export default {"descr":"Descr__descr___k3pms"};